import React from "react";
import NumberFormat from "react-number-format";
import CoursesCard from "./CoursesCard";
import Icons from "./Icons";

interface Props {
  userIsInUk?: boolean;
  courses?: any[];
  enrolmentCount?: number;
  courseCount?: number;
}

const Landing: React.FC<Props> = ({
  userIsInUk,
  courses,
  courseCount,
  enrolmentCount,
}) => {
  return (
    <>
      <Icons />
      <section className="hero">
        <div className="hero-pattern" aria-hidden="true">
          <svg
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid slice"
            xmlns="http://www.w3.org/2000/svg"
          >
            <svg x="10%" y="25%" overflow="visible">
              <use
                href="#home-blob-1"
                fill="#FFA5BC"
                transform="scale(1.75)"
                opacity="0.15"
              />
            </svg>
            <svg x="80%" y="80%" overflow="visible">
              <use
                href="#home-blob-1"
                fill="#B798F2"
                transform="scale(2.17)"
                opacity="0.15"
              />
            </svg>
            <svg x="45%" y="-10%" overflow="visible">
              <use
                href="#home-blob-2"
                fill="#E8EBFF"
                transform="scale(1.47)"
                opacity="0.5"
              />
            </svg>
            <svg x="60%" y="60%" overflow="visible">
              <use
                href="#home-blob-1"
                fill="#F3EC7A"
                transform="scale(0.98)"
                opacity="0.3"
              />
            </svg>
          </svg>
        </div>
        <span className="big-42-wallpaper" aria-hidden="true">
          42
        </span>
        <div className="container">
          <div className="learners-from">
            <span className="label">Join learners from</span>
            <div className="partner-logos">
              <svg
                className="logo-abinbev"
                viewBox="0 0 1863 343"
                role="img"
                aria-label="AB InBev"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs id="lg-abinbev-defs6">
                  <clipPath id="lg-abinbev-clipPath20">
                    <path
                      id="lg-abinbev-path18"
                      d="m265 977c-82.4 29.5-165 50.9-247 64.9 24.8-133 70.7-264 140-389 202-365 553-594 935-653-13.9 399-338 802-827 977zm46.7 405c647 56.4 1144 560 1204 1173-282 49.9-582 7.42-852-142-392-217-628-607-664-1022 101-14.6 205-18.3 311-9.01zm981-401c-16.5-360 96.9-695 299-961 111 26.6 221 68.2 326 126 626 346 853 1134 507 1760-74.6 135-170 251-279 347-483-225-827-704-853-1273z"
                    ></path>
                  </clipPath>
                  <linearGradient
                    id="lg-abinbev-linearGradient26"
                    x2="1"
                    gradientTransform="matrix(2586 0 0 -2586 0 1288)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      id="lg-abinbev-stop22"
                      stopColor="#cd9f28"
                      offset="0"
                    ></stop>
                    <stop
                      id="lg-abinbev-stop24"
                      stopColor="#ecd80b"
                      offset="1"
                    ></stop>
                  </linearGradient>
                </defs>
                <g id="lg-abinbev-g10" transform="matrix(1.33 0 0 -1.33 0 343)">
                  <g id="lg-abinbev-g12" transform="scale(.1)">
                    <g id="lg-abinbev-g14">
                      <g
                        id="lg-abinbev-g16"
                        clipPath="url(#lg-abinbev-clipPath20)"
                      >
                        <path
                          id="lg-abinbev-path28"
                          d="m265 977c-82.4 29.5-165 50.9-247 64.9 24.8-133 70.7-264 140-389 202-365 553-594 935-653-13.9 399-338 802-827 977zm46.7 405c647 56.4 1144 560 1204 1173-282 49.9-582 7.42-852-142-392-217-628-607-664-1022 101-14.6 205-18.3 311-9.01zm981-401c-16.5-360 96.9-695 299-961 111 26.6 221 68.2 326 126 626 346 853 1134 507 1760-74.6 135-170 251-279 347-483-225-827-704-853-1273"
                          fill="url(#lg-abinbev-linearGradient26)"
                        ></path>
                      </g>
                    </g>
                    <path
                      id="lg-abinbev-path30"
                      d="m6859 229h373v2158h-373v-2158"
                      fill="#110f0d"
                    ></path>
                    <path
                      id="lg-abinbev-path32"
                      d="m8360 1796c-186 0-364-70.2-479-257v225h-336v-1534h360v812c0 63.6 5.64 124 16.9 169 41.4 165 159 262 333 262 179 0 283-89.8 316-269 7.99-42.9 11.8-104 11.8-161v-813h360v908c0 102-10.2 194-33.9 272-78 261-286 387-548 387"
                      fill="#110f0d"
                    ></path>
                    <path
                      id="lg-abinbev-path34"
                      d="m10143 580c-39-9.2-104-12.6-146-12.6h-413v608h445c39.9 0 85.5-4 118-11.2 175-38.8 242-177 242-293 0-153-98.5-258-245-292zm-560 1468h332c75.6 0 156-10.4 208-34.2 90-41.4 138-119 138-235 0-117-51.7-197-143-238-45.9-20.6-113-31.5-190-31.5h-344zm840-666c146 112 207 241 207 424 0 275-170 481-430 551-67.4 18.2-177 28.8-304 28.8h-682v-2158h764c149 0 249 14.2 346 48.7 256 90.4 433 289 433 581 0 244-116 417-334 524"
                      fill="#110f0d"
                    ></path>
                    <path
                      id="lg-abinbev-path36"
                      d="m13587 1763-384-1096-390 1096h-390l609-1534h332l608 1534h-386"
                      fill="#110f0d"
                    ></path>
                    <path
                      id="lg-abinbev-path38"
                      d="m11247 1117c25.8 221 205 366 422 366 228 0 402-151 428-366zm419 679c-437 0-776-351-776-810 0-424 334-789 791-789 334 0 592 192 725 503h-366c-82.4-123-193-190-353-190-238 0-394 140-442 356h1197c9 51 11.5 93.8 10.9 146-3.9 412-320 785-788 785"
                      fill="#110f0d"
                    ></path>
                    <path
                      id="lg-abinbev-path40"
                      d="m5912 568h-444v620c56.3 2.37 112 3.64 165 3 404-5.23 639-123 639-332 0-188-168-291-360-291zm-444 1480h317c72.4 0 133-8.24 175-21.8 120-39.2 186-130 186-276 0-135-68.2-224-176-265-103 17.5-218 27.1-347 27.2-48.2 0.04-101-0.72-155-2.41zm-2e3 -1329 479 1241 279-744c-289-132-546-302-758-497zm2837 660c156 114 211 284 211 427 0 275-170 481-430 551-67.4 18.1-177 28.8-304 28.8h-682v-911c-190-28.8-375-73.9-550-133l-426 1043h-343l-881-2158h359c311 328 681 564 1067 720l270-720h407l-341 836c146 41.6 292 72.5 437 93.5v-929l185-0.172-0.06-0.359h651c460 0 707 270 707 630 0 218-108 404-338 521"
                      fill="#110f0d"
                    ></path>
                  </g>
                </g>
              </svg>
              <svg
                className="logo-ogilvy"
                viewBox="0 0 155 60"
                role="img"
                aria-label="Ogilvy"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  transform="translate(-256 -51.5)"
                  d="m291 74.6c0 10.3-5.25 18.5-13.1 18.5-7.72 0-13.3-7.82-13.3-18.6 0-10.3 5.25-18.5 13.1-18.5 7.72 0 13.3 7.82 13.3 18.6m8.67-0.291c0-11.6-8.96-20.8-21.8-20.8-11.8 0-21.9 8.4-21.9 21.3 0 11.6 8.96 20.8 21.8 20.8 11.8 0 21.9-8.4 21.9-21.3m19.1 4.2c0 4.09-1.89 7.59-4.83 7.59-2.83 0-5.07-3.09-5.07-7.82 0-4.03 1.89-7.59 4.89-7.59 2.77 0 5.01 3.09 5.01 7.82m20.1-16c0-2.92-2.65-5.08-7.55-5.08-6.72 0-11.9 4.32-11.9 10.9 0 0.525 0.059 0.934 0.059 1.34a14.3 14.3 0 0 0-5.48-1.05c-5.3 0-11.7 3.21-11.7 10.2a9.11 9.11 0 0 0 5.01 7.94c-4.72 0.641-7.43 3.15-7.43 7.06 0 3.97 3.18 6.83 9.14 6.13l8.61-1.05c4.3-0.525 5.72 0.991 5.72 3.21 0 3.85-3.66 6.95-9.49 6.95-4.66 0-6.37-1.64-6.37-3.97 0-0.35 0.06-0.817 0.06-1.17a2.3 2.3 0 0 0-2.3-2.45 2.59 2.59 0 0 0-2.65 2.86c0 3.85 3.72 7.3 11.3 7.3 8.55 0 14-5.49 14-11.8 0-5.02-4.07-7.76-9.67-7.06l-9.85 1.22c-3.24 0.409-4.24-0.642-4.24-2.28 0-1.93 2.12-3.44 9.49-3.44h0.118c5.36 0 11.7-3.21 11.7-10.2a8.5 8.5 0 0 0-2.36-5.9 7.49 7.49 0 0 1-0.707-3.62c0-5.14 3.54-8.05 7.19-8.05 1.53 0 2 0.233 2 1.28 0 0.291-0.059 0.525-0.059 0.875a3.69 3.69 0 0 0 7.37-0.175m18.3 30.6-2.89-0.292a0.8 0.8 0 0 1-0.707-0.875v-40.4l-10.4 2.63v1.22l2.95 0.934a0.949 0.949 0 0 1 0.649 0.993v34.4a1.16 1.16 0 0 1-1.3 1.11l-2.63 0.053-2.79-0.053a1.16 1.16 0 0 1-1.3-1.11v-23.3l-10.4 2.63v1.22l2.95 0.934a0.949 0.949 0 0 1 0.649 0.993v17.7a0.8 0.8 0 0 1-0.707 0.875l-2.42 0.292v1.87h28.3v-1.87zm53.8-21.8v-1.81h-10.1v1.75l2.36 0.467c0.826 0.175 1.06 0.818 0.531 2.1l-5.42 13c-0.236 0.525-0.532 0.525-0.709 0l-5.07-13c-0.532-1.34-0.236-1.92 0.588-2.1l2.36-0.467v-1.75h-21v1.75l2.36 0.467c0.825 0.175 1.12 0.818 0.589 2.1l-5.25 13.7c-0.236 0.526-0.53 0.526-0.707 0l-5.31-13.7c-0.471-1.34-0.236-1.92 0.59-2.1l2.36-0.467v-1.75h-13.3v1.81l1.3 0.291a2.26 2.26 0 0 1 1.77 1.46l9.02 21.9h4.07l9.02-21.9c0.471-1.17 1-1.64 1.94-1.64h0.353a1.84 1.84 0 0 1 1.83 1.4l9.43 22.8-2.54 5.95c-1.65 3.97-2.89 4.67-4.42 4.67-0.648 0-1.36-0.117-2.06-0.117a2.75 2.75 0 0 0-2.95 2.68c0 1.58 1.3 2.68 3.36 2.68 2.95 0 5.84-2.34 8.25-7.94l12.9-29.8a3.23 3.23 0 0 1 2.59-2.16z"
                  fill="#EB3F43"
                  fillRule="evenodd"
                ></path>
              </svg>
              <svg
                className="logo-google"
                viewBox="0 0 272 92"
                role="img"
                aria-label="Google"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m116 47.2c0 12.8-9.99 22.2-22.2 22.2s-22.2-9.41-22.2-22.2c0-12.9 9.99-22.2 22.2-22.2s22.2 9.32 22.2 22.2zm-9.74 0c0-7.98-5.79-13.4-12.5-13.4s-12.5 5.46-12.5 13.4c0 7.9 5.79 13.4 12.5 13.4s12.5-5.55 12.5-13.4z"
                  fill="#EA4335"
                ></path>
                <path
                  d="m164 47.2c0 12.8-9.99 22.2-22.2 22.2s-22.2-9.41-22.2-22.2c0-12.8 9.99-22.2 22.2-22.2s22.2 9.32 22.2 22.2zm-9.74 0c0-7.98-5.79-13.4-12.5-13.4s-12.5 5.46-12.5 13.4c0 7.9 5.79 13.4 12.5 13.4s12.5-5.55 12.5-13.4z"
                  fill="#FBBC05"
                ></path>
                <path
                  d="m210 26.3v39.8c0 16.4-9.66 23.1-21.1 23.1-10.8 0-17.2-7.19-19.7-13.1l8.48-3.53c1.51 3.61 5.21 7.87 11.2 7.87 7.31 0 11.8-4.51 11.8-13v-3.19h-0.34c-2.18 2.69-6.38 5.04-11.7 5.04-11.1 0-21.2-9.66-21.2-22.1 0-12.5 10.2-22.3 21.2-22.3 5.29 0 9.49 2.35 11.7 4.96h0.34v-3.61h9.25zm-8.56 20.9c0-7.81-5.21-13.5-11.8-13.5-6.72 0-12.4 5.71-12.4 13.5 0 7.73 5.63 13.4 12.4 13.4 6.63 0 11.8-5.63 11.8-13.4z"
                  fill="#4285F4"
                ></path>
                <path d="M225 3v65h-9.5V3h9.5z" fill="#34A853"></path>
                <path
                  d="m262 54.5 7.56 5.04c-2.44 3.61-8.32 9.83-18.5 9.83-12.6 0-22-9.74-22-22.2 0-13.2 9.49-22.2 20.9-22.2 11.5 0 17.1 9.16 19 14.1l1.01 2.52-29.6 12.3c2.27 4.45 5.8 6.72 10.8 6.72 4.96 0 8.4-2.44 10.9-6.14zm-23.3-7.98 19.8-8.23c-1.09-2.77-4.37-4.7-8.23-4.7-4.95 0-11.8 4.37-11.6 12.9z"
                  fill="#EA4335"
                ></path>
                <path
                  d="m35.3 41.4v-9.41h31.7c0.31 1.64 0.47 3.58 0.47 5.68 0 7.06-1.93 15.8-8.15 22-6.05 6.3-13.8 9.66-24 9.66-19 0-34.9-15.5-34.9-34.4s16-34.4 34.9-34.4c10.5 0 18 4.12 23.6 9.49l-6.64 6.64c-4.03-3.78-9.49-6.72-17-6.72-13.9 0-24.7 11.2-24.7 25s10.8 25 24.7 25c8.99 0 14.1-3.61 17.4-6.89 2.66-2.66 4.41-6.46 5.1-11.6l-22.5 0.01z"
                  fill="#4285F4"
                ></path>
              </svg>
              <svg
                className="logo-disney"
                viewBox="0 0 700 294"
                role="img"
                aria-label="Disney"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M602.2 128.6c-11.7 2.7-42.6 4.2-42.6 4.2l-3.8 12.2s15.3-1.3 26.5-.2c0 0 3.6-.3 4 4 .2 4.4-.3 9-.3 9s-.3 2.7-4 3.4c-4.3.7-33.3 2-33.3 2L544 179s-1.7 3.6 2.2 2.6c3.6-1 34-6.8 38-6 4.2 1 9 6.8 7.6 12-1.6 6.3-32 25.7-50.4 24.4 0 0-9.7.6-17.8-12.5-7.8-12.5 2.7-36 2.7-36s-4.7-11-1.2-15c0 0 2-1.7 8-2.2l7.5-15.4s-8.5.5-13.5-5.7c-4.6-6-5-8.6-1.4-10.2 3.8-2 39-8.3 63.2-7.5 0 0 8.5-1 16 13.7 0 0 3.4 6-2.6 7.4M511 187.8c-3 7.3-11.3 15-21.3 10.3-10.2-4.8-26.3-37.6-26.3-37.6s-6-12.2-7.2-11.8c0 0-1.3-2.4-2 11-1 13.3.2 39.2-5.3 43.3-5 4-11 2.3-14.4-2.4-2.8-4.7-4-16-2.4-35.7 1.8-19.7 6.3-40.7 12-47.2 6-6.6 10.8-1.8 12.6 0 0 0 7.7 7 20.7 27.7l2.2 3.8s11.8 19.7 13 19.6c0 0 1 1 1.8.2 1.2-.3.8-6.7.8-6.7S493 141 482 105c0 0-1.6-4.6-.5-9 1-4 5.3-2 5.3-2s16.6 8 24.7 35c8 27 2.6 51.5-.4 58.8M429.6 118.5c-1.6 2.8-2.3 6.7-9.2 7.8 0 0-67 4.7-70.3 9.4 0 0-2.2 2.8 1.4 3.5 3.8.8 19 2.8 26.2 3.2 7.8 0 34 .2 43.6 12 0 0 5.5 5.6 5.3 18.3-.2 13-2.5 17.6-7.6 22.3-5.3 4.4-50.7 24.8-80-6.4 0 0-13.4-15 4.7-26.4 0 0 13-8 46.3 1.3 0 0 10 3.6 9.6 7.3-.6 4-8.3 8-19.5 7.8-10.8-.3-18.8-5.5-17.2-4.6 1.5.5-11.7-6.4-15.8-1.7-4 4.4-3 7 1 9.7 10 5.8 49.3 3.7 61-9.4 0 0 4.7-5.3-2.4-9.6-7-4-27.4-6.5-35.3-6.8-7.5-.4-35.6 0-39.8-7.3 0 0-4-5.2.4-19.4 4.6-15 37.3-20.8 51.5-22 0 0 39-1.6 46.3 6.4 0 0 1 1.8-.2 4.5M319 206.4c-4.7 3.5-14.7 2-17.6-2-2.8-3.5-3.8-17.3-3.3-39 .7-22.2 1-49.4 6-53.8 5-4.3 8-.5 10 2.4 2 3 4.6 6.3 5 13.2.6 7 2.3 43 2.3 43s2.2 32.8-2.3 36.2M329 89.4c-13.8 4.7-23.2 3.2-31.2-.3-3.5 6.3-5.6 8.2-8.2 8.6-4 .4-7.5-6-8-8-.8-1.5-2.7-4.2-.4-10.3-7.8-7-8.4-16.4-7-22.7 1.8-7.4 15-35.2 55-38.5 0 0 19.6-1.4 23 9h.6s19 0 18.6 17c0 17-21 38.2-42.4 45.5m17.8-48.7c-12.6 2-32 18.8-41.3 32.7 14.3 2.6 39.3 1.6 50.5-21 0 0 5.3-14.2-9.2-11.7m-55.3 11c-4 6.5-4.2 10.4-2.3 13 4.7-7 13-18 25.5-26.6-9.6 1-17.7 5-23.2 13.6M632.2 205.7c-9.2 22.6-17 45.5-21.5 79.8 0 0-1 6.7-6.5 4.5-5.5-2-14.5-11-16.5-23.7-2-16.6 5.4-44.6 20.5-76.8-4.4-7-7.5-17.4-5-32 0 0 4-27 31-51.4 0 0 3.2-2.7 5-1.8 2.2 1 1.3 9.6-.5 14-1.6 4.2-13.6 25-13.6 25s-7.5 14.2-5.4 25.3c14.2-21.8 46.5-66 66.5-52 12.7 9 12.7 38 3.2 54.8-7.5 13.3-28.7 40.8-57 34.4m41.6-68c-7.4 8-20.6 23.2-31 43.8 11-1.2 21.7-7.3 25-10.4 5.3-4.7 17.5-17.4 15.6-34.2 0 0-1.2-8.8-9.6.8M226 217.5c-35.4 10.8-68.8 5.8-87 1-.5 7.4-1.3 10.5-2.5 11.7-1.4 1.6-13 8.2-19.4-1.2-2.8-4.5-4.2-12.6-5-20-41-18.6-60-46-60.6-47-1-1-10.3-10.7-1-22.7 8.7-10.8 37.5-21.7 63.3-26 1-22 3.4-39 6.5-46.5 3.7-9 8.4-1 12.6 5 3.4 4.5 5.5 23.8 5.7 39.2 16.8-.8 27 .4 45.7 4 24.6 4.2 41 16.8 39.7 31-1.2 14-14 19.8-19 20.2-5 .4-13-3.3-13-3.3-5.6-2.6-.5-5 6-7.8 7.2-3.5 5.6-7 5.6-7-2.6-8-34.5-13.3-66.2-13.3 0 17.5.7 46.5 1.2 63.4 22.2 4.2 38.8 3.3 38.8 3.3s81-2.3 83.3-54c2.5-51.8-81-101.4-142.5-117C56.8 14.4 22 25.8 19 27.3c-3.3 1.6-.3 2.2-.3 2.2S22 30 28 32c6 2 1.2 5 1.2 5C18.7 40.6 7 38.5 4.7 33.7c-2.3-4.7 1.5-9 6-15.3 4.2-6.5 9-6.3 9-6.3 76-26.5 168.8 21 168.8 21 86.8 43.8 101.6 95.3 100 115.3-1.4 19.7-9 53-62.5 69.2M59 146c-8.6 4-2.6 10.4-2.6 10.4 16.2 17.3 36 28.2 55 35 2.2-30 2-40.7 2-55.8C84 137.6 67 142.4 59 146"></path>
              </svg>
            </div>
          </div>
          <div className="main-grid">
            <div>
              <h1 id="hero-title">
                Mini MBAs for <em>Big Thinkers.</em>
              </h1>
              <p className="tagline">
                Critical business and creativity skills,{" "}
                <strong>personalised to your role and goals</strong>. Taught by
                the people who wrote the book. Literally.
              </p>
              <div className="cta-row">
                <a href="/courses" className="btn btn-blue">
                  Explore Courses
                </a>
                <a
                  href="#"
                  data-smooth-scroll-to="#pricing-container"
                  className="btn btn-white"
                >
                  View Pricing →
                </a>
              </div>
              <div className="stats" aria-label="Key statistics">
                <div>
                  <strong>
                    {" "}
                    <NumberFormat
                      value={enrolmentCount}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                    +
                  </strong>{" "}
                  Happy learners
                </div>
                <div>
                  <strong>{courseCount}+</strong> Courses
                </div>
                <div>
                  <strong>82 NPS</strong> Learner satisfaction
                </div>
              </div>
            </div>
            <CoursesCard courses={courses} userIsInUk={userIsInUk} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Landing;
